import { useCallback, useMemo } from "react";

import { useGetCountries } from "api/queries/common/useGetCountries";

/**
 * Resolves an ISO alpha-3 country code (e.g. a commodity's `origin_country`) to its display name.
 * Falls back to the code itself when the country list hasn't loaded or doesn't contain it.
 */
export default function useCountryNameByIsoCode() {
  const { data: countries = [] } = useGetCountries({ useV2: true, refetchOnMount: false });

  const namesByIsoCode = useMemo(
    () => new Map(countries.map((country) => [country.value?.toUpperCase(), country.label])),
    [countries],
  );

  return useCallback(
    (isoCode?: string | null) => {
      if (!isoCode) return "";
      return namesByIsoCode.get(isoCode.toUpperCase()) ?? isoCode;
    },
    [namesByIsoCode],
  );
}
